import React from 'react';
import { COLORS } from '@constants';
import styled from 'styled-components';
import { Icon } from '../../../Icon';

export const StyledIcon = styled(({ ...props }) => <Icon {...props} />)`
    margin-top: 4px;

    &:hover {
        color: ${COLORS.$gray100Black};
    }
`;
